var initObj = {
  age: {
    low: 18,
    high: 90,
  },
  distance: 0,
  proof: [],
  photo: [],
  signinRecent: false,
  postCheck: false,
  qaCheck: false,
  keyword: '',
  name: '',
  loginLimit: 90,
  region: [],
  marriage: [],
  job: [],
  academic: [],
  lifestyle: [],
  height: {
    low: 120,
    high: 230,
  },
  style: [],
  association: [],
  child: [],
  smorking: [],
  drinking: [],
  gambling: [],
  pet: [],
  blood: [],
  constellation: [],
  income: [],
  personality: [],
  opposite: [],
};

export function lsSearchConditionInit() {
  localStorage.setItem('SearchCondition', JSON.stringify(initObj));
}

export function lsSearchConditionInitCheck() {
  let lsObj = JSON.parse(localStorage.getItem('SearchCondition'));

  if (JSON.stringify(initObj) === JSON.stringify(lsObj)) {
    return true;
  }
  else {
    return false;
  }
}
